import { Redirect } from 'react-router';
import TermsAndConditionsDialog from 'components/TermsAndConditionsDialog';
import MedicalProviderNetworkDialog from 'components/MedicalProviderNetworkDialog';
import useAuthentication from 'hooks/useAuthentication';
import Logger from 'utilities/logger';

const withTermsAndConditionsProtection = Component => {
  const C = props => {
    const logger = Logger('terms protection');
    const { user } = useAuthentication();

    if (!user) {
      logger.debug('Not authenticated');
      return <Redirect push exact to="/login" />;
    }

    const validate = group => {
      if (!user.groups || !user.groups[group]) {
        return false;
      }
      if (!Array.isArray(user.groups[group])) {
        return false;
      }
      if (user.groups[group].length === 0) {
        return false;
      }
      return true;
    };

    if (validate('terms') && validate('mpn')) {
      return <Component {...props} />;
    }

    if (!validate('terms')) {
      logger.debug('Pending Terms and conditions');
      return <TermsAndConditionsDialog />;
    }

    logger.debug('Pending MPN');
    return <MedicalProviderNetworkDialog />;
  };

  const name = Component.displayName || Component.name;
  C.displayName = `withTermsAndConditionsProtection(${name})`;

  return C;
};

export default withTermsAndConditionsProtection;
